<script setup>
const emit = defineEmits(['close'])

function closeModal() {
  emit('close')
}
</script>

<template>
  <div class="bg-gray-900 bg-opacity-50 fixed inset-0 z-40" />
  <div tabindex="-1"
    class="overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 w-full md:inset-0 h-modal md:h-full justify-center items-center flex"
    @click.self="closeModal()">
    <div class="relative p-4 w-full h-full md:h-96 max-w-7xl">
      <!-- Modal content -->
      <div class="relative bg-white rounded-lg shadow">
        <!-- Modal header -->
        <div class="p-4 rounded-t flex justify-between items-center">
          <slot name="header" />
          <button
            class="text-gray-400 bg-transparent hover:bg-slate-300 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center"
            type="button" @click="closeModal">
            <slot name="close-icon">
              <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clip-rule="evenodd"></path>
              </svg>
            </slot>
          </button>
        </div>
        <!-- Modal body -->
        <div class="p-6" :class="$slots.header ? '' : 'pt-0'">
          <slot name="body" />
        </div>
        <!-- Modal footer -->
        <div v-if="$slots.footer" class="p-6 rounded-b">
          <slot name="footer" />
        </div>
      </div>
    </div>
  </div>
</template>
